import styled from 'styled-components';
import { toRem, baseVariables } from '../../../styles';

export const StyledSecurePaymentFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(16)};
  width: 100%;

  /* Card Number Row */
  .card-number-row {
    width: 100%;
    margin-bottom: ${toRem(16)};
  }
  .card-nickname {
    margin-bottom: ${toRem(16)};
  }
  .card-number-wrapper {
    position: relative;
  }
  .icon-cancel {
    z-index: 1;
    cursor: pointer;
    position: absolute;
    right: 0rem;
    bottom: 0.625rem;
    font-size: 1rem;
    color: rgb(0, 0, 0);
    top: ${toRem(5)};
  }

  /* Second Row: Expiry, CVV, Postal */

  .details-grid {
    display: grid;
    gap: ${toRem(32)};

    /* md and above: column count matches visible fields */
    @media ${baseVariables.mediaQuery.md} {
      gap: ${toRem(12)};
      grid-template-columns: repeat(3, 1fr);
      &.two-columns {
        grid-template-columns: repeat(2, 1fr);
      }
      &.one-column {
        grid-template-columns: 1fr;
      }
    }
    &.two-columns {
      .cvv-tooltip {
        left: 91%;
      }
    }
  }

  /* Info icon with tooltip */
  .icon-information {
    position: absolute;
    right: ${toRem(8)};
    font-size: ${toRem(16)};
    color: ${baseVariables.color['neutral40']};
    cursor: pointer;
    top: ${toRem(17)};
  }
`;

export const StyledInputDiv = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  .input-box {
    border: ${baseVariables.color['neutral40']} solid ${toRem(1)};
    border-radius: ${toRem(4)};
    position: relative;
    padding: ${toRem(12)} ${toRem(12)};
    display: flex;
    flex-direction: column;

    &:focus-within > label {
      color: ${baseVariables.color['base10']};
    }

    label {
      position: absolute;
      top: ${toRem(-15)};
      letter-spacing: ${toRem(1.3)};
      background: ${baseVariables.color['base20']};
      padding: ${toRem(6)} ${toRem(8)} ${toRem(6)} ${toRem(6)};
      font-size: ${baseVariables.font['fontS']};
      color: ${baseVariables.color['neutral40']};
      font-weight: ${baseVariables.font['fontWeightMedium']};
      line-height: ${baseVariables.font['lineHeightXs']};
      width: auto;
      inset-inline-start: ${toRem(12)};
      z-index: 10;
    }

    .cardNickName {
      padding: ${toRem(12)} ${toRem(48)} ${toRem(12)} ${toRem(16)};
      border: none;
    }

    .secure-fields__input,
    input {
      width: 100%;
      height: ${toRem(34)};
      font-size: ${baseVariables.font['fontL']};
      border: none;
      outline: none;
      color: ${baseVariables.color['ambassadorSolid']};
    }

    .input-with-icon {
      position: relative; /* Make icon the positioning context */
    }

    .cvv-tooltip {
      position: absolute;
      bottom: calc(80%); /* ABOVE the icon */
      left: 50%; /* Center relative to icon */
      transform: translateX(-50%);
      background-color: ${baseVariables.color['base20']};
      border-radius: ${toRem(8)};
      box-shadow: 0 ${toRem(4)} ${toRem(12)} rgba(0, 0, 0, 0.15);
      width: calc(110%);
      height: auto;
      padding: ${toRem(16)} ${toRem(8)};
      z-index: 100;

      p {
        margin-bottom: 0;
        font-size: ${toRem(14)};
        line-height: ${toRem(21)};
      }

      .tooltip-header {
        display: flex;
        justify-content: space-between;
        font-weight: ${baseVariables.font['fontWeightMedium']};
        margin-bottom: ${toRem(8)};

        span {
          font-size: ${toRem(18)};
          line-height: ${toRem(23)};
        }
      }

      .close-icon {
        width: ${toRem(32)};
        height: ${toRem(32)};
        border-radius: ${toRem(4)};
      }
      .icon-clear {
        align-items: center;
        justify-content: center;
        display: flex;
        font-size: ${toRem(24)};
      }

      @media ${baseVariables.mediaQuery.md} {
        right: 0;
        transform: translateX(-50%);
        width: ${toRem(344)};
        .tooltip-pointer {
          left: auto;
          right: calc(25%);
          transform: none;
          bottom: ${toRem(-8)};
        }
      }
    }

    .tooltip-pointer {
      position: absolute;
      top: ${toRem(11)};
      right: ${toRem(8)};
      border-left: ${toRem(8)} solid transparent;
      border-right: ${toRem(8)} solid transparent;
      border-top: ${toRem(8)} solid ${baseVariables.color['base20']};
      z-index: 101;
    }

    &.is-error {
      label {
        color: var(--t-form-error-color);
      }
      border: var(--t-form-error-color) solid ${toRem(1)};

      input:focus {
        border: var(--t-form-error-color) solid ${toRem(1.5)};
      }
    }
  }

  .secure-fields__input::placeholder {
    color: ${baseVariables.color['neutral40']};
  }

  /* Applied to the card number field */
  .secure-fields__input--number {
    color: ${baseVariables.color['ambassadorSolid']};
  }
  /* Applied to the expiry date field */
  .secure-fields__input--expiry-date {
    color: ${baseVariables.color['ambassadorSolid']};
  }
  /* Applied to the security code field */
  .secure-fields__input--security-code {
    color: ${baseVariables.color['ambassadorSolid']};
  }
  /* Applied to a focused field */
  .secure-fields__input[data-secure-fields-focused] {
    color: ${baseVariables.color['ambassadorSolid']};
  }
  /* Applied to an invalid field */
  .secure-fields__input[data-secure-fields-invalid] {
    color: ${baseVariables.color['ambassadorSolid']};
  }
  /* Applied to an autofilled field */
  .secure-fields__input[data-secure-fields-autofilled] {
  }
`;

export const StyledError = styled.p`
  margin: ${toRem(4)} 0 0;
  color: ${baseVariables.color['alert50']};
  font-size: ${baseVariables.font['fontXs']};
  line-height: ${baseVariables.font['lineHeightXs']};
  &.icon-information::before {
    margin-right: ${toRem(9.3)};
  }
  &.information {
    margin-left: ${toRem(16)};
  }
`;
